export default __webpack_public_path__ + "static/media/eyephotomagazine.28bb4c48.jpeg";